import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  sectionTitle1: {
    id: 'course-authoring.course-rerun.sidebar.section-1.title',
    defaultMessage: 'When will my course re-run start?',
  },
  sectionDescription1: {
    id: 'course-authoring.course-rerun.sidebar.section-1.description',
    defaultMessage: 'The new course is set to start on',
  },
  sectionTitle2: {
    id: 'course-authoring.course-rerun.sidebar.section-2.title',
    defaultMessage: 'What transfers from the original course?',
  },
  sectionDescription2: {
    id: 'course-authoring.course-rerun.sidebar.section-2.description',
    defaultMessage: 'The new course has the same course outline and content as the original course. All problems, videos, announcements, and other files are duplicated to the new course.',
  },
  sectionTitle3: {
    id: 'course-authoring.course-rerun.sidebar.section-3.title',
    defaultMessage: 'What does not transfer from the original course?',
  },
  sectionDescription3: {
    id: 'course-authoring.course-rerun.sidebar.section-3.description',
    defaultMessage: 'You are the only member of the new course\'s staff. No students are enrolled in the course, and there is no student data. There is no content in the discussion topics or wiki.',
  },
  sectionLink4: {
    id: 'course-authoring.course-rerun.sidebar.section-4.link',
    defaultMessage: 'Learn more about course re-runs',
  },
});

export default messages;
